<template>
    <div>
        <el-tag class="tagSelf" v-for="(item, index) in items" type='success'
            :key="index" 
            :effect="item.selected ? 'dark' : 'plain'"
            @click="choose(item)">
            {{item.name}}
        </el-tag>
    </div>
</template>

<script>
export default {
    name: 'TypeTags',
    props: {
        tags: {
            type: Array,
            default: []
        }
    },
    data: vm =>({
        defaultNum: 13, //默认显示个数
        allTags: [], 
        items: []
    }),
    created(){
        this.render()
    },
    methods: {
        render(){
            this.tags.forEach( tag =>{
                const obj = Object.assign({selected: false}, tag)
                this.allTags.push(obj)
            })
            if(this.tags.length > this.defaultNum){
                this.items = this.allTags.slice(0, this.defaultNum)
                this.items.push({
                    name: '展开',
                    selected: false
                })
            }else{
                this.items = this.allTags.slice(0, this.tags.length)
            }     
        },
        choose(item){
            if(item.name == '展开'){
                this.items = this.allTags.slice(0, this.tags.length)
                this.items.push({name: '折叠',selected: false})
                return
            }else if(item.name == '折叠'){
                this.items = this.allTags.slice(0, this.defaultNum)
                this.items.push({
                    name: '展开',
                    selected: false
                })
                return
            }
            this.items.forEach(obj => {
                obj.selected = false
            })
            item.selected = true

            this.$emit('chooseCallback', item.name)
        }
    }
}
</script>

<style scoped>
.tagSelf{
    margin: 0px 10px 10px 0px;
    min-width: 14%;
    text-align: center;
    cursor: pointer;
}
</style>